import React from "react";

import { useTranslation } from "utils";

import { Icon, Typography } from "components";

const GO_DEEPER_ITEMS = [
  { key: "yieldSoilHealth", iconName: "tabler/plant-2" },
  { key: "refineRealData", iconName: "tabler/calculator" },
  { key: "compareScenarios", iconName: "tabler/git-compare" },
  { key: "coverCropRecommendations", iconName: "klim/plant-ai" },
  { key: "keyInsights", iconName: "tabler/bulb", fullWidth: true },
] as const;

// Landing-page teaser for the full scenario tool: heading + five feature cards (last spans the row).
export const GoDeeperCard = () => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <div className="onboarding-go-deeper" data-testid="onboarding-go-deeper">
      <Typography variant="h4">{t("scenarioLanding.goDeeper.title")}</Typography>
      <div className="onboarding-go-deeper__cards">
        {GO_DEEPER_ITEMS.map((item) => (
          <div key={item.key} className={`onboarding-go-deeper__card${"fullWidth" in item && item.fullWidth ? " onboarding-go-deeper__card--wide" : ""}`}>
            <span className="onboarding-go-deeper__icon">
              <Icon iconName={item.iconName} size="m" />
            </span>
            <div className="onboarding-go-deeper__card-text">
              <Typography variant="paragraph-m">{t(`scenarioLanding.goDeeper.${item.key}.title`)}</Typography>
              <Typography variant="paragraph-s" color="grey-600">
                {t(`scenarioLanding.goDeeper.${item.key}.description`)}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
